export { default } from './Chart';



// WEBPACK FOOTER //
// ./src/design-system/atoms/Chart/index.jsx